<template>
    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col ml-n2">
                                <h4 class="mb-1">
                                    <a>{{$t('accountsWithdrawals.show.purchasePayments')}} <strong> {{item.code}}</strong></a>
                                </h4>
                            </div>
                            <div class="col-auto">
                                <router-link :to="path+'/'+item.id + '/edit'" class="btn btn-sm btn-primary" :title="$t('accountsWithdrawals.show.edit')">
                                    <i class="fas fa-edit"></i>
                                </router-link>
                                <a @click="print(item.id)" class="btn btn-sm btn-primary" :title="$t('accountsWithdrawals.show.Printing')">
                                    <i class="fas fa-print"></i>
                                </a>
                                <a :href="$linkGnirator('/purchasepayments/' + item.id + '/pdf')" download class="btn btn-sm btn-primary" :title="$t('accountsWithdrawals.show.DownloadPDF')">
                                    <i class="fas fa-download"></i>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-header-title">
                            <i class="fal fa-credit-card-front"></i>
                            {{$t('accountsWithdrawals.show.PaymentDetails')}}
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-9">
                                <table class="table table-sm table-nowrap customed-table-small">
                                    <tbody>
                                        <tr>
                                            <th scope="row">{{$t('accountsWithdrawals.show.PaymentNumber')}} </th>
                                            <td>{{item.code}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">{{$t('accountsWithdrawals.show.PaymentDate')}}</th>
                                            <td>{{$dateFormat(item.date)}} </td>
                                        </tr>

                                        <tr>
                                            <th scope="row">
                                              {{ $t("accountsDeposits.show.user") }}
                                            </th>
                                            <td>{{ item.user ? item.user.name : "--" }}</td>
                                          </tr>

                                        <tr>
                                            <th scope="row">{{$t('accountsWithdrawals.show.accountName')}}</th>
                                            <td>{{item.account.id ? item.account.name : "--"}} </td>
                                        </tr>
                                       
                                        <tr>
                                            <th scope="row">{{$t('accountsWithdrawals.show.referenceNumber')}}</th>
                                            <td>{{item.refrance != null? item.refrance : '--'}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">
                                              {{ $t('employeesSalaries.show.thatAbout') }}
                                            </th>
                                            <td>
                                              {{ item.description != null ? item.description : "--" }}
                                            </td>
                                          </tr>
                                        <tr>
                                            <th scope="row">{{$t('accountsWithdrawals.show.cost')}}</th>
                                            <td scope="row">{{item.cost != null ? item.cost : '--'}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">{{$t('accountsWithdrawals.show.Treasury')}}</th>
                                            <td>
                                                <router-link :to="'/safes/' + item.safe.id" v-if="item.safe">{{ item.safe.name}}</router-link>
                                                    {{item.safe ? '' : '--'}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-3">
                                <div class="price-show">
                                    <div class="price-content">
                                        <p>{{$t('accountsWithdrawals.show.cash')}}</p>
                                        <h1>{{item.cost}} {{$option.currency}}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h4 class="card-header-title">
                            <i class="fal fa-user-alt"></i>
                            {{$t('accountsWithdrawals.show.purchasePayments')}}
                        </h4>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm table-nowrap">
                            <thead>
                                <tr>
                                    <th scope="col">{{$t('accountsWithdrawals.show.accountName')}}</th>
                                    <th scope="col">{{$t('employeesSalaries.show.thatAbout')}}</th>
                                    <th scope="col">{{$t('accountsDeposits.show.cost')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">
                                      <router-link :to="'/accounts/' + item.account.id"  >{{item.account.name}}</router-link>
                                    </th>
                                    <td>{{ item.description }}</td>
                                    <td>{{$moneyFormat(item.cost)}} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <showFile/>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import showFile from '../elements/show/showFile.vue';

    export default {
        data() {
            return {
                path: '/accountsWithdrawals',
                item: {},

                printInvoice: false,
            }
        },
        mounted() {
            this.getitem();
        },
        methods: {
            getitem() {
                axios.get(this.$linkGnirator(this.path + '/' + this.$route.params.id))
                    .then(response => {
                        this.item = response.data;
                    });
            },
            print (id) {
                this.$parent.printedPurchasePayment = this.item;
            }
        },
        components: {
            showFile,
        }
    };

</script>
